import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getInquiryQuotationList = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/inquiry-quotation/', {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      die_group: groupId,
      ordering: ordering,
    },
  });
};
const getInquiryArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/inq-quot-archive-list/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};
const getInquiryQuotationById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/inquiry-quotation/${id}`, {
    headers: authHeader(),
  });
};
const convertToQuotation = (inquiryId, formData) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/inquiry/${inquiryId}/convert-to-quotation/`,
    formData,
    { headers: authHeader() }
  );  
}
const addInquiryQuotation = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/inquiry-quotation/`,
    formData,
    { headers: authHeader() }
  );
};

const editInquiryQuotation = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/inquiry-quotation/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};

const deleteInquiryQuotation = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/inquiry-quotation/${id}/`,
    { headers: authHeader() }, // Authentication header
  );
};
const unArchiveInquiryRecord = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/inquiry-quotation/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() }, // Authentication header
  );
};

const deleteInquiryDetails = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/inquiry-quotation-details/${id}/`,
    { headers: authHeader() }, // Authentication header
  );
};

const inquiryQuotationService = {
  getInquiryQuotationList,
  getInquiryArchiveList,
  getInquiryQuotationById,
  convertToQuotation,
  addInquiryQuotation,
  editInquiryQuotation,
  deleteInquiryQuotation,
  unArchiveInquiryRecord,
  deleteInquiryDetails
};
export default inquiryQuotationService;


